import { type Fee } from 'reservations/booking/types';
import { PER_GUEST, getFeeText } from 'reservations/feePolicy/helpers';
import { formatDollar } from 'reservations/feePolicy/helpers/formatDollar';

export const getFormattedFeeToCharge = (
  { calcType, fee }: Fee,
  partySize: number
): string => {
  const feeType = getFeeText(calcType);
  // Fee is sent as total amount in cents, so we need to convert to dollars
  // and then divide by the number of guests if the fee is per guest
  const feeInDollars = +fee / 100 / (feeType === PER_GUEST ? partySize : 1);

  return `${formatDollar(feeInDollars)} ${feeType}`;
};
